// Inside the iOS app's WebViews, report failures to Cloud Logging (a device
// build keeps no console); does nothing in a browser. First, so it sees
// everything the imports below log — see install.js.
import './utils/hostIssues/install';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Build info is regenerated on every build (gitignored). Wrap in try/catch so
// `npm start` (no build step) doesn't break if the file hasn't been generated.
try {
  // eslint-disable-next-line global-require
  const BUILD_INFO = require('./buildInfo');
  console.log(
    `[build] ${BUILD_INFO.shaShort} on ${BUILD_INFO.branch} @ ${BUILD_INFO.time}`
  );
  // Expose globally so support / debugging can fish it out without DevTools tab switching
  if (typeof window !== 'undefined') window.__BUILD__ = BUILD_INFO;
} catch (err) {
  console.log('[build] dev (no buildInfo — run a deploy build to generate)');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
